module.exports = __webpack_public_path__ + "img/SES_280330030.be14b127.jpg";